import { render, staticRenderFns } from "./Ver.vue?vue&type=template&id=64f8d1b4&scoped=true&"
import script from "./Ver.vue?vue&type=script&lang=js&"
export * from "./Ver.vue?vue&type=script&lang=js&"
import style0 from "./Ver.vue?vue&type=style&index=0&id=64f8d1b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f8d1b4",
  null
  
)

export default component.exports